import { Injectable } from '@angular/core';
import { Visit } from '../models/visit.model';

@Injectable()
export class VisitService {
    private readonly storageKey = 'visits';

    constructor() {
    }

    get visits(): Visit[] {
        const value = localStorage.getItem(this.storageKey);

        return JSON.parse(value);
    }

    public logVisit(path: string): void {
        const visits = this.visits || [];

        const newVisit: Visit = {
            TimeStamp: Date.now(),
            Path: path
        };

        visits.push(newVisit);
        this.saveVisits(visits);
    }

    private saveVisits(visits: Visit[]): void {
        localStorage.setItem(this.storageKey, JSON.stringify(visits));
    }
}
